// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"6ee491bf","73":"14ee988c","431":"af3dc515","489":"95ab1f0c","661":"add6b2e0","787":"8af56ae3","860":"b80bf4e2","881":"5432da9e","908":"567317c7"}[chunkId] + ".chunk.js";
};